// Mutations
export var MutationTypeCodes;
(function (MutationTypeCodes) {
    MutationTypeCodes["SET_CURRENT_SEARCH_REQUEST"] = "SET_CURRENT_SEARCH_REQUEST";
    MutationTypeCodes["SET_CURRENT_RESPONSE"] = "SET_CURRENT_RESPONSE";
    MutationTypeCodes["RESET_FILTERS"] = "RESET_FILTERS";
    MutationTypeCodes["ADD_CATEGORY"] = "ADD_CATEGORY";
    MutationTypeCodes["REMOVE_CATEGORY"] = "REMOVE_CATEGORY";
    MutationTypeCodes["SET_SORT_OPTION"] = "SET_SORT_OPTION";
    MutationTypeCodes["SET_SEARCH_STATUS"] = "SET_SEARCH_STATUS";
    MutationTypeCodes["RESET_OFFSET"] = "RESET_OFFSET";
})(MutationTypeCodes || (MutationTypeCodes = {}));
export var ResourceTypeMutationCodes;
(function (ResourceTypeMutationCodes) {
    ResourceTypeMutationCodes["SET_RESOURCE_TYPE"] = "SET_RESOURCE_TYPE";
    ResourceTypeMutationCodes["REMOVE_RESOURCE_TYPE"] = "REMOVE_RESOURCE_TYPE";
})(ResourceTypeMutationCodes || (ResourceTypeMutationCodes = {}));
